export const MB_IN_BYTES = {
  THIRTY: 31457280,
}
